var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavigationComponent'),_c('v-main',[_c('router-view')],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }